module.exports = __webpack_public_path__ + "static/img/main-bg.fa6ebba3.png";